<div class="noticia-content hoverable" fxLayout="column" fxFlex="1 1 auto" (click)="listarNoticia()">
    <div class="header" fxLayout="row" fxLayoutAlign="center center" [ngClass]="[noticia.categoria.cor_template]">

        <div class="titulo h1" fxFlex>
            {{noticia.titulo}}
        </div>
    </div>

    <div [ngSwitch]="tipoMidia" class="content midia-preview" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
        <div *ngSwitchCase="tipoMidiaEnum.Imagem" class="preview-image">
            <app-secured-image [src]="getUrlMidia()" [alt]="noticia.titulo" [imgClass]="'secured-image-preview'"></app-secured-image>
        </div>

        <div *ngSwitchCase="tipoMidiaEnum.Video" class="preview-image">
            <app-secured-image [src]="getUrlThumbnail()" [alt]="noticia.titulo" [imgClass]="'secured-image-preview'"></app-secured-image>
        </div>

        <div *ngSwitchCase="tipoMidiaEnum.Download" class="preview-image">
            <mat-icon aria-hidden="false" aria-label="Anexo">attachment</mat-icon>
        </div>

        <div *ngSwitchDefault class="texto">
            <p>{{htmlToText(noticia.texto) | slice:0:150}}<span *ngIf="noticia.texto?.length > 150">...</span></p>
        </div>


    </div>


    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
        <div class="user"><span>por </span><span>{{noticia.user.name}}</span></div>
    </div>
</div>